{
  "name": "ogi-bio-frontend",
  "version": "0.1.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "build:doc": "npx compodoc -p tsconfig.doc.json --theme Readthedocs -d dist/apps/documentation/compodoc",
    "serve:doc": "npx compodoc -p tsconfig.doc.json --theme Readthedocs -d dist/apps/documentation/compodoc -s -r 5000 -o",
    "ngd": "npx ngd -p tsconfig.doc.json -o",
    "source": "source-map-explorer dist/ogi-bio-frontend/**/*.js",
    "lint": "ng lint",
    "test:e2e": "playwright test --grep-invert @token",
    "test:e2e:token": "playwright test --grep @token --project=unauthenticated-chromium --workers=1"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.25",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.25",
    "@angular/compiler": "21.2.25",
    "@angular/core": "21.2.25",
    "@angular/forms": "21.2.25",
    "@angular/material": "21.2.14",
    "@angular/platform-browser": "21.2.25",
    "@angular/platform-browser-dynamic": "21.2.25",
    "@angular/router": "21.2.25",
    "@angular/service-worker": "21.2.25",
    "@intercom/messenger-js-sdk": "0.0.17",
    "@types/intercom-web": "2.8.26",
    "@types/plotly.js": "3.0.8",
    "angular-plotly.js": "20.0.0",
    "angularx-qrcode": "^21.0.5",
    "d3": "7.3.0",
    "d3-regression": "1.3.10",
    "lottie-web": "5.9.4",
    "node": "20.19.0",
    "plotly.js-dist-min": "3.3.0",
    "rxjs": "7.8.1",
    "tslib": "2.3.0",
    "typescript": "5.9.3",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "21.4.0",
    "@angular-eslint/eslint-plugin": "21.4.0",
    "@angular-eslint/eslint-plugin-template": "21.4.0",
    "@angular-eslint/schematics": "21.4.0",
    "@angular-eslint/template-parser": "21.4.0",
    "@angular/build": "21.2.28",
    "@angular/cli": "21.2.28",
    "@angular/compiler-cli": "21.2.25",
    "@playwright/test": "1.61.1",
    "@types/angular": "1.8.5",
    "@types/d3": "7.4.0",
    "@types/jasmine": "3.8.2",
    "@types/node": "12.20.41",
    "@typescript-eslint/eslint-plugin": "8.65.0",
    "@typescript-eslint/parser": "8.65.0",
    "dotenv": "^17.4.2",
    "eslint": "10.8.0",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-prettier": "5.5.6",
    "jasmine-core": "4.0.0",
    "prettier": "3.3.3"
  },
  "overrides": {
    "glob": "11.1.0"
  }
}
